<template>
  <div>
    <label class="d-block">
      {{ $tc('action_plan.label', 2) }}
    </label>
    <v-select
      v-model="selectedActionPlan"
      :options="actionPlans"
      :clearable="false"
      :reduce="(val) => val.value"
      input-id="id_unit"
      :multiple="false"
      @option:selected="onOptionSelected"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import {EventBus} from "@/libs/event-bus";

export default {
  components: {
    vSelect,
  },
  props: {
    actionPlanId: {
      type: String | Number,
    }
  },
  data() {
    return {
      selectedActionPlan: null,
    };
  },
  mounted() {
    if (!this.actionPlans.length) {
      store.dispatch("action_plan/getAll");
    }
  },
  computed: {
    actionPlans() {
      return store.getters["action_plan/getSelectedItems"];
    },
  },
  methods: {
    onOptionSelected(option) {
      setTimeout(() => this.showAlert(option), 300);
    },
    showAlert(actionPlan) {
      const title = this.$t('action_plan.replace_modal.title', { name: actionPlan.label });
      const description = this.$t('action_plan.replace_modal.description');

      this.$swal({
        title: title,
        text: description,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `${this.$t("actions.accept")}`,
        cancelButtonText: `${this.$t("actions.cancel")}`,
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          EventBus.emit(`add_action_plan_${this.actionPlanId}`, {actionPlanId: actionPlan.value});
        }
      }).finally(() => {
        this.selectedActionPlan = null;
      });
    }
  }
};
</script>

<style></style>
